// removed by extract-text-webpack-plugin
module.exports = {"container":"_2TcQq","action-create":"_3emed","action-about":"_1zUro","white":"_264Ju"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CrossSellBanner/CrossSellBanner.scss
// module id = ./src/components/CrossSellBanner/CrossSellBanner.scss
// module chunks = 5